import { User } from '@supabase/supabase-js';

/**
 * 获取用户头像 URL
 * @param user - Supabase User 对象
 * @param options - 可选参数
 * @param options.cacheBuster - 缓存破坏参数（用于头像更新后立即显示）
 * @param options.fallbackName - 如果用户没有名称，使用此名称生成默认头像
 * @returns 头像 URL
 */
export const getUserAvatarUrl = (
    user: User | null | undefined,
    options?: { cacheBuster?: string; fallbackName?: string }
): string => {
    if (!user) {
        const displayName = options?.fallbackName || 'User';
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=1A162F&color=fff`;
    }

    const userName = user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User';
    const baseUrl = user?.user_metadata?.avatar_url || user?.user_metadata?.picture;

    if (!baseUrl) {
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&background=1A162F&color=fff`;
    }

    // 如果有 cacheBuster，添加到 URL
    if (options?.cacheBuster) {
        return `${baseUrl}?t=${options.cacheBuster}`;
    }

    return baseUrl;
};

/**
 * 获取成员头像 URL（用于成员列表等场景）
 * @param member - 成员对象
 * @returns 头像 URL
 */
export const getMemberAvatarUrl = (member: {
    logoUrl?: string;
    name?: string;
    displayName?: string;
    email?: string;
}): string => {
    if (member.logoUrl) return member.logoUrl;

    const displayName = member.name || member.displayName || member.email || 'U';
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=1A162F&color=fff`;
};
